import { getColorFromKey, getRabbitColorFromKey } from 'constants/helper';

class CohortQuery {
  constructor({ designations, managers }) {
    this.designations = designations;
    this.managers = managers;
  }

  static fromJSON({ designations, managers }) {
    return new CohortQuery({
      designations,
      managers,
    });
  }
}

export class Cohort {
  constructor({
    uuid,
    name,
    // query,
    // employee,
  }) {
    this.uuid = uuid;
    this.name = name;
    // this.query = query;
    // this.employee = employee;
  }

  static fromJSON({
    uuid,
    name,
    // query,
    // employee,
  }) {
    return new Cohort({
      uuid,
      name,
      // query: CohortQuery.fromJSON(query),
      // employee // parse employee as employeeObject if required in future.
    });
  }
}

export class GroupByKeys {
  constructor({ uuid, keyName, displayName, enabled }) {
    this.uuid = uuid;
    this.keyName = keyName;
    this.displayName = displayName;
    this.enabled = enabled;
  }

  static fromJSON({ uuid, keyName, displayName, enabled }) {
    return new GroupByKeys({
      uuid,
      keyName,
      displayName,
      enabled,
    });
  }
}

export class Source {
  constructor({ uuid, keyName, displayName, enabled, performanceEvaluationGrid }) {
    this.uuid = uuid;
    this.keyName = keyName;
    this.displayName = displayName;
    this.enabled = enabled;
    this.performanceEvaluationGrid = performanceEvaluationGrid;
  }

  static fromJSON({ uuid, keyName, displayName, enabled, performanceEvaluationGrid }) {
    return new Source({
      uuid,
      keyName,
      displayName,
      enabled,
    });
  }
}

export class GridAxis {
  constructor({ label, size }) {
    this.label = label;
    this.size = size;
  }

  static fromJSON({ label, size }) {
    return new GridAxis({ label, size });
  }
}

export class MetricsCard {
  constructor({ rating, reviewState, scores, status, type }) {
    this.rating = rating;
    this.reviewState = reviewState;
    this.scores = scores;
    this.status = status;
    this.type = type;
  }

  static fromJSON({ rating, reviewState, scores, status, type }) {
    return new MetricsCard({
      rating,
      reviewState,
      scores: scores.map((score) => MetricsCardScore.fromJSON(score)),
      status,
      type,
    });
  }
}

export class AggregatedScore {
  constructor({ key, displayName, count, score, viewType, color }) {
    this.key = key;
    this.displayName = displayName;
    this.count = count;
    this.score = score;
    this.viewType = viewType;
    this.color = color;
  }

  static fromJSON({ key, displayName, count, score, viewType, color = 'grey' }) {
    return new AggregatedScore({
      key,
      displayName,
      count,
      score,
      viewType,
      color,
    });
  }
}

export class MetricsCardScore {
  constructor({ key, displayName, count, score, viewType }) {
    this.key = key;
    this.count = count;
    this.score = score;
    this.displayName = displayName;
    this.viewType = viewType;
  }

  static fromJSON({ key, count, score, displayName, viewType }) {
    return new MetricsCardScore({
      key,
      count,
      score,
      displayName,
      viewType,
    });
  }
}

export class PerformanceGridBox {
  constructor({ color, label, count, percentage, gridData, employeeDetails, isDisplayPictures }) {
    this.color = color;
    this.count = count;
    this.label = label;
    this.percentage = percentage;
    this.scoreRange = gridData ? gridData.scoreRange : null;
    this.employeeDetails = employeeDetails ?? [];
    this.isDisplayPictures = isDisplayPictures ?? false;
  }

  static fromJSON({ data, noRatingData, isDisplayPictures }, type = 'rabbit') {
    const chartData = data?.map((boxObj) =>
      boxObj.map(
        ({ color, ...rest }) =>
          new PerformanceGridBox({
            color: type === 'rabbit' ? getRabbitColorFromKey(color) : getColorFromKey(color),
            ...rest,
          })
      )
    );
    const noRating = new PerformanceGridBox({
      ...noRatingData,
      color:
        type === 'rabbit'
          ? getRabbitColorFromKey(noRatingData.color?.toLowerCase())
          : getColorFromKey(noRatingData.color?.toLowerCase()),
    });

    return {
      chartData,
      noRating,
      isDisplayPictures,
    };
  }
}

export class PerformancePreviewGridBox {
  constructor({ color, label, count, percentage, gridData, employeeDetails }) {
    this.color = color;
    this.count = count;
    this.label = label;
    this.percentage = percentage;
    this.scoreRange = gridData ? gridData.scoreRange : null;
    this.employeeDetails = employeeDetails ?? [];
  }

  static fromJSON({ gridDetails, ratingMap, ratingDetails, expandedViewRatingDetails }, type) {
    const chartData = gridDetails?.map((boxObj) =>
      boxObj.map(
        ({ color, ...rest }) =>
          new PerformanceGridBox({
            color: type === 'rabbit' ? getRabbitColorFromKey(color) : getColorFromKey(color),
            ...rest,
          })
      )
    );
    return {
      chartData,
      ratingMap,
      ratingDetails,
      expandedViewRatingDetails,
    };
  }
}
